module.exports = __webpack_public_path__ + "static/media/load.de93231d.gif";